/* @flow */

import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";

import { Well } from "react-bootstrap";

class LoadingPanel extends React.Component<{
    [x: string]: any;
}> {
    static propTypes = {
        messageId: PropTypes.string.isRequired
    };

    render() {
        return (
            <Well className="ex-search-query-badge">
                <div className="h4 no-margin">
                    <i className="icon-spinner icon-lg" />
                    &nbsp;&nbsp;
                    <FormattedMessage id={this.props.messageId} />
                </div>
            </Well>
        );
    }
}

export default LoadingPanel;
